export const API_NAME = 'main'
export const GRAPHQL_ROUTE = '/graphql'
